import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _defineProperty from "/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutProperties.js";
import "core-js/modules/es6.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.for-each";
var _excluded = ["children"];
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 菜单
 * */
import { cloneDeep } from 'lodash';
import { includeArray, getHeaderName, getMenuSider, getSiderSubmenu } from '@/libs/system';
import { GetHeaderMenu } from '@api/account';
import router from '@/router';
import { frameInRoutes, otherRoutes } from '@/router/routes';
// 配置
import Setting from '@/setting';

// 根据 menu 配置的权限，过滤菜单
function filterMenu(menuList, access, lastList) {
  menuList.forEach(function (menu) {
    // let menuAccess = menu.meta.auth;
    var menuAccess = false; // 先跳过权限校验
    var showMenu = menu.meta.showMenu === false;
    if (!showMenu && (!menuAccess || includeArray(menuAccess, access))) {
      var newMenu = {};
      for (var i in menu) {
        if (i !== 'children') newMenu[i] = cloneDeep(menu[i]);
      }
      if (menu.children && menu.children.length) newMenu.children = [];
      lastList.push(newMenu);
      menu.children && filterMenu(menu.children, access, newMenu.children);
    }
  });
  return lastList;
}
export default {
  namespaced: true,
  state: {
    // 顶部菜单
    header: [],
    // 侧栏菜单
    sider: [],
    // 当前顶栏菜单的 name
    headerName: '',
    // 当前所在菜单的 path
    activePath: '',
    // 展开的子菜单 name 集合
    openNames: [],
    // 2.3.0 所有的菜单
    menuSider: [],
    // 2.4.0 菜单徽标
    menuBadge: []
  },
  getters: {
    /**
     * @description 根据 user 里登录用户权限，对侧边菜单进行鉴权过滤
     * */
    filterSider: function filterSider(state, getters, rootState) {
      var userInfo = rootState.admin.user.info;
      // @权限
      var access = userInfo.access;
      if (access && access.length) {
        return filterMenu(state.sider, access, []);
      } else {
        return filterMenu(state.sider, [], []);
      }
    },
    /**
     * @description 根据 user 里登录用户权限，对顶栏菜单进行鉴权过滤
     * */
    filterHeader: function filterHeader(state, getters, rootState) {
      // console.log('对顶栏菜单进行鉴权过滤 state', cloneDeep(state.header))
      var userInfo = rootState.admin.user.info;
      // @权限
      var access = userInfo.access;
      // console.log('对顶栏菜单进行鉴权过滤 权限', userInfo.access)
      if (access && access.length) {
        return state.header.filter(function (item) {
          // console.log('item.auth', item, item.auth, item.children)
          var state = true;
          // if (item.auth && !includeArray(item.auth, access)) state = false;
          if (item.children && item.children.length) {
            item.children = item.children.filter(function (child) {
              var state = true;
              // if (child.auth && !includeArray(child.auth, access)) state = false;
              return state;
            });
          }
          return state;
        });
      } else {
        return state.header.filter(function (item) {
          var state = true;
          // if (item.auth && item.auth.length) state = false;
          if (item.children && item.children.length) {
            item.children = item.children.filter(function (child) {
              var state = true;
              // if (child.auth && child.auth.length) state = false;
              return state;
            });
          }
          return state;
        });
      }
    },
    /**
     * @description 当前 header 的全部信息
     * */
    currentHeader: function currentHeader(state) {
      return state.header.find(function (item) {
        return item.name === state.headerName;
      });
    },
    /**
     * @description 在当前 header 下，是否隐藏 sider（及折叠按钮）
     * */
    hideSider: function hideSider(state, getters) {
      var visible = false;
      if (getters.currentHeader && 'hideSider' in getters.currentHeader) visible = getters.currentHeader.hideSider;
      return visible;
    }
  },
  mutations: {
    /**
     * @description 设置侧边栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu
     */
    setSider: function setSider(state, menu) {
      state.sider = menu;
    },
    /**
     * @description 设置顶栏菜单
     * @param {Object} state vuex state
     * @param {Array} menu menu
     */
    setHeader: function setHeader(state, menu) {
      state.header = menu;
    },
    /**
     * @description 设置当前顶栏菜单 name
     * @param {Object} state vuex state
     * @param {Array} name headerName
     */
    setHeaderName: function setHeaderName(state, name) {
      state.headerName = name;
    },
    /**
     * @description 设置当前所在菜单的 path，用于侧栏菜单高亮当前项
     * @param {Object} state vuex state
     * @param {Array} path fullPath
     */
    setActivePath: function setActivePath(state, path) {
      state.activePath = path;
    },
    /**
     * @description 设置当前所在菜单的全部展开父菜单的 names 集合
     * @param {Object} state vuex state
     * @param {Array} names openNames
     */
    setOpenNames: function setOpenNames(state, names) {
      state.openNames = names;
    },
    /**
     * @description 2.3.0，设置所有菜单
     * @param {Object} state vuex state
     * @param {Array} menuSider menuSider
     * */
    setMenuSider: function setMenuSider(state, menuSider) {
      state.menuSider = menuSider;
    },
    /**
     * @description 2.4.0 设置全部的侧边菜单的徽标
     * */
    setAllMenuBadge: function setAllMenuBadge(state, data) {
      state.menuBadge = data;
    },
    /**
     * @description 2.4.0 新增或修改某个侧边菜单的徽标
     * */
    setMenuBadge: function setMenuBadge(state, _ref) {
      var path = _ref.path,
        badge = _ref.badge;
      var menuBadge = cloneDeep(state.menuBadge);
      var menuIndex = menuBadge.findIndex(function (item) {
        return item.path === path;
      });
      if (menuIndex >= 0) {
        menuBadge[menuIndex] = badge;
        state.menuBadge = menuBadge;
      } else {
        state.menuBadge.push(badge);
      }
    },
    /**
     * @description 2.4.0 删除某个侧边菜单的徽标
     * */
    removeMenuBadge: function removeMenuBadge(state, path) {
      var menuIndex = state.menuBadge.findIndex(function (item) {
        return item.path === path;
      });
      if (menuIndex >= 0) state.menuBadge.splice(menuIndex, 1);
    }
  },
  actions: {
    getHeaderMenu: function () {
      var _getHeaderMenu = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
        var state, commit, dispatch, rootState;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              state = _ref2.state, commit = _ref2.commit, dispatch = _ref2.dispatch, rootState = _ref2.rootState;
              return _context3.abrupt("return", new Promise(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
                  var userInfo, brandInfo, params;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        // 开始请求登录接口
                        userInfo = rootState.admin.user.info;
                        brandInfo = rootState.admin.brandInfo.brandInfo;
                        params = {
                          system: 1,
                          menuType: 2,
                          tenantId: brandInfo.tenantId,
                          userId: userInfo.id
                        };
                        _context2.next = 5;
                        return GetHeaderMenu(params).then(/*#__PURE__*/function () {
                          var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
                            var header, items, userMenus, headerMenus, siderMenus;
                            return _regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) switch (_context.prev = _context.next) {
                                case 0:
                                  header = res.header, items = res.items;
                                  if (!(header.code === 200)) {
                                    _context.next = 12;
                                    break;
                                  }
                                  // 权限路由数据源动态处理
                                  // 设置顶部菜单
                                  // console.log('权限下返回所有菜单 items', cloneDeep(items))
                                  userMenus = filterAsyncUserRouter(items); // console.log('格式化 权限下返回所有菜单 userMenus', cloneDeep(userMenus))
                                  // const headerMenus = cloneDeep(userMenus)
                                  headerMenus = userMenus.map(function (item) {
                                    var children = item.children,
                                      data = _objectWithoutProperties(item, _excluded);
                                    return _objectSpread({}, data);
                                  });
                                  _context.next = 6;
                                  return commit('setHeader', headerMenus);
                                case 6:
                                  // 权限下返回所有菜单，再通过name和顶部匹配
                                  siderMenus = [];
                                  userMenus.map(function (item) {
                                    if (item && item.children && item.children.length) {
                                      item.children.map(function (cItem) {
                                        siderMenus.push(cItem);
                                      });
                                    } else {
                                      siderMenus.push(item);
                                    }
                                  });
                                  _context.next = 10;
                                  return commit('setMenuSider', cloneDeep(siderMenus));
                                case 10:
                                  _context.next = 12;
                                  return dispatch('getSiderMenu', cloneDeep(siderMenus));
                                case 12:
                                  // 结束
                                  resolve();
                                case 13:
                                case "end":
                                  return _context.stop();
                              }
                            }, _callee);
                          }));
                          return function (_x4) {
                            return _ref4.apply(this, arguments);
                          };
                        }()).catch(function (err) {
                          // console.log('err: ', err);
                          reject(err);
                        });
                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x2, _x3) {
                  return _ref3.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getHeaderMenu(_x) {
        return _getHeaderMenu.apply(this, arguments);
      }
      return getHeaderMenu;
    }(),
    getSiderMenu: function getSiderMenu(_ref5) {
      var state = _ref5.state,
        commit = _ref5.commit,
        dispatch = _ref5.dispatch;
      return new Promise(/*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve, reject) {
          var menuSider, asyncRoutes, menuHeader, path, headerName, filterMenuSider, openNames;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                // 设置侧边菜单
                menuSider = state.menuSider;
                asyncRoutes = menuSider && menuSider.length ? filterAsyncRouter(menuSider) : [];
                if (!(asyncRoutes && asyncRoutes.length)) {
                  _context4.next = 8;
                  break;
                }
                menuHeader = cloneDeep(state.header);
                menuHeader.forEach(function (hItem) {
                  if (hItem.name === asyncRoutes[0].header) {
                    hItem.path = asyncRoutes[0].path;
                    // console.log('[vuex-menu] 侧边菜单修改顶部菜单 header', hItem.name, hItem.path)
                  }
                });
                _context4.next = 8;
                return commit('setHeader', menuHeader);
              case 8:
                // console.log('[vuex-menu] 修改后顶部菜单 state.header', cloneDeep(state.header))
                // console.log('[vuex-menu] 修改后侧边菜单 state.menuSider', cloneDeep(state.menuSider))
                // console.log('[vuex-menu] 修改完 菜单 asyncRoutes', cloneDeep(asyncRoutes))
                asyncRoutes.push({
                  path: "*",
                  redirect: "/404",
                  hidden: true
                }); // 追加404页面
                // asyncRoutes = asyncRoutes.filter(v => v.name !== 'dashboard')
                asyncRoutes.forEach(function (item) {
                  router.addRoute(item);
                  router.options.routes.push(item);
                });
                // console.log('[vuex-menu] 添加菜单路由 router', router)
                _context4.next = 12;
                return dispatch('admin/page/updatePool', {
                  routes: [].concat(_toConsumableArray(frameInRoutes), _toConsumableArray(asyncRoutes))
                }, {
                  root: true
                });
              case 12:
                _context4.next = 14;
                return dispatch('admin/page/open', _objectSpread({}, router.currentRoute), {
                  root: true
                });
              case 14:
                // 防止刷新的时候菜单丢失
                path = router.currentRoute.fullPath; // console.log('防止刷新的时候菜单丢失 path', path)
                // console.log('Setting.dynamicSiderMenu', Setting.dynamicSiderMenu)
                if (!Setting.dynamicSiderMenu) {
                  // console.log('防止刷新的时候菜单丢失 menuSider', menuSider)
                  headerName = getHeaderName(path, menuSider); // console.log('防止刷新的时候菜单丢失 headerName', headerName)
                  // 在 404 时，是没有 headerName 的
                  if (headerName !== null) {
                    commit('setHeaderName', headerName);
                    filterMenuSider = getMenuSider(menuSider, headerName); // console.log('防止刷新的时候菜单丢失 filterMenuSider', filterMenuSider)
                    commit('setSider', filterMenuSider);
                    commit('setActivePath', path);
                    openNames = getSiderSubmenu(path, menuSider);
                    commit('setOpenNames', openNames);
                  }
                }
                resolve();
                _context4.next = 22;
                break;
              case 19:
                _context4.prev = 19;
                _context4.t0 = _context4["catch"](0);
                reject(_context4.t0);
              case 22:
              case "end":
                return _context4.stop();
            }
          }, _callee4, null, [[0, 19]]);
        }));
        return function (_x5, _x6) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
  }
};

// 后端路由数据-处理路由
export function filterAsyncUserRouter(router) {
  var newRouter = [];
  if (!router || !router.length) {
    return newRouter;
  }
  router.forEach(function (headerRoute) {
    // 顶部菜单无子项时，认定无效菜单直接过滤
    var title = headerRoute.title,
      name = headerRoute.name,
      icon = headerRoute.icon,
      menuType = headerRoute.menuType,
      menuId = headerRoute.menuId,
      parentId = headerRoute.parentId,
      items = headerRoute.items;
    if (headerRoute && items && items.length) {
      // 顶部菜单
      var childrenRoute = filterSiderRouter(items);
      var newHeaderRoute = {
        path: childrenRoute[0].path,
        // 避免path错误，重新指向第一子项path
        title: title,
        custom: icon,
        hideSider: false,
        name: name,
        menuId: menuId,
        parentId: parentId,
        menuType: menuType,
        children: childrenRoute // 子项菜单
      };
      // 无子项时，不添加route.children，避免干扰路由菜单/路由tab渲染
      if (!newHeaderRoute.children || !newHeaderRoute.children.length) {
        delete newHeaderRoute.children;
      }
      newRouter.push(newHeaderRoute);
    }
  });
  return newRouter;
}
export function filterSiderRouter(router) {
  // 左侧菜单
  var newRouter = [];
  if (!router || !router.length) {
    return newRouter;
  }
  router.forEach(function (siderRoute) {
    var title = siderRoute.title,
      name = siderRoute.name,
      icon = siderRoute.icon,
      path = siderRoute.path,
      header = siderRoute.header,
      meta = siderRoute.meta,
      menuType = siderRoute.menuType,
      menuId = siderRoute.menuId,
      parentId = siderRoute.parentId,
      template = siderRoute.template,
      items = siderRoute.items;
    // 设置左侧菜单标签实际路径（存在子项时，重定向至第一子项路径）
    var redirectPath = path;
    var redirectName = '';
    if (siderRoute && items && items.length) {
      redirectName = items[0].name;
    }
    if (name === 'membership-grade' || name === 'membership-integral') {
      meta.refresh = true;
    }
    meta.cache = true;
    var newSiderRoute = {
      path: redirectPath,
      title: title,
      custom: icon,
      name: name,
      header: header,
      // 生成的时候就是正确的 固定的
      menuId: menuId,
      parentId: parentId,
      menuType: menuType,
      meta: meta,
      component: template,
      children: filterSiderRouter(items)
    };
    // 仅当存在子路由时，配置newSiderRoute，避免空-导致重定向死循环
    if (redirectName) {
      newSiderRoute.redirect = {
        name: redirectName // 动态遍历取第一子级的第一个路由name
      };
    }
    // 无子项时，不添加route.children，避免干扰路由菜单/路由tab渲染
    if (!newSiderRoute.children || !newSiderRoute.children.length) {
      delete newSiderRoute.children;
    }
    newRouter.push(newSiderRoute);
  });
  return newRouter;
}

// 处理路由
export function filterAsyncRouter(router) {
  return router.filter(function (route) {
    // route.children = filterChildren(route.children);
    // console.log(route);
    route.component = loadView(route.component);
    // 加载详情页的路由
    if (otherRoutes[route.name] && otherRoutes[route.name].length) {
      route.children = route.children || [];
      route.children = [].concat(_toConsumableArray(route.children), _toConsumableArray(otherRoutes[route.name]));
    }
    // 如果数组有子组件就递归
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children);
    }
    // 无子项时，不添加route.children，避免干扰路由菜单/路由tab渲染
    if (!route.children || !route.children.length) {
      delete route.children;
    }
    return true;
  });
}

// 处理子组件
export function filterChildren(childrenMap) {
  var lastRouter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var children = [];
  childrenMap.forEach(function (el, index) {
    if (el.children && el.children.length) {
      el.children.forEach(function (c) {
        c.path = el.path + "/" + c.path;
        children.push(c);
      });
    }

    // 假如只有二级子路由
    if (lastRouter) {
      el.path = lastRouter.path + "/" + el.path;
      // console.log(el.path);
    }
    children = children.concat(el);
  });
  return children;
}
export var loadView = function loadView(view) {
  if (view && typeof view === 'string' && view.slice(-4) === '.vue') {
    // 绝对地址
    return function () {
      return import("@/".concat(view.slice(0, -4), ".vue"));
    };
  } else {
    // 相对地址
    return function () {
      return import("@/".concat(view, "/index.vue"));
    };
  }
};